import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./UserGroupItem.module.css";
import Button from "shared/Button";
import NoteIcon from "DreamStream/Shared/NoteIcon";
import StatusIcon from "../StatusIcon";
import { FaPlusSquare } from "react-icons/fa";
import GroupNotesModal from "DreamStream/Shared/GroupNotesModal";
import { Link } from "react-router-dom";

/**
 * Interactive component. Displays information about a group in the users groups list.
 */
export function UserGroupItem({ groupInfo, onRemove }) {
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [editNotesModalOpen, setEditNotesModalOpen] = useState(false);

  const group = {
    name: "Albus and Minerva McGongail Diamonship",
    id: "9636550",
    notes: "This is where you can view the notes...",
  };

  return (
    <div className={styles.gridContainer}>
      <div className={(styles.gridItem, styles.name)}>
        <Link to="/dreamstream/groups">{groupInfo.name}</Link>
      </div>
      <div className={styles.gridItem}>{groupInfo.groupType}</div>
      <div className={(styles.gridItem, styles.statusDiv)}>
        <StatusIcon status={groupInfo.status} />
      </div>
      <div className={styles.gridItem}>{groupInfo.pluginType}</div>
      <div className={styles.gridItem}>
        {groupInfo.notes !== "" || null ? (
          <>
            <div className={(styles.gridItem, styles.notesDiv)}>
              <NoteIcon
                onClick={() => {
                  setNotesModalOpen(true);
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div className={(styles.gridItem, styles.notesDiv)}>
              <FaPlusSquare
                className={styles.plusIcon}
                onClick={() => {
                  setEditNotesModalOpen(true);
                }}
              />
            </div>
          </>
        )}
      </div>

      <Button
        className={styles.button}
        onClick={onRemove}
        size="tiny"
        children="Remove"
      />

      <GroupNotesModal
        isOpen={notesModalOpen}
        groupInfo={group}
        edit={false}
        onClose={() => setNotesModalOpen(false)}
        onClick={() => setEditNotesModalOpen(true)}
      />

      <GroupNotesModal
        isOpen={editNotesModalOpen}
        groupInfo={group}
        edit={true}
        onClick={() => setEditNotesModalOpen(false)}
      />
    </div>
  );
}

UserGroupItem.propTypes = {
  /**
   * Object with the groups info.
   */
  groupInfo: PropTypes.shape({
    name: PropTypes.string,
    groupType: PropTypes.string,
    status: PropTypes.string,
    pluginType: PropTypes.string,
    notes: PropTypes.bool,
    groupId: PropTypes.string,
  }),

  /**
   * 	Function called when remove is clicked
   */
  onRemove: PropTypes.func,
};
